<footer>
    <div [@animateFooter]>
        <ul class="footer-left-bar d-none d-md-block">
            <li>
                <a href="https://github.com/sivaDev1212" target='_blank'>
                    <i class="fab fa-github"></i>
                </a>
            </li>
            <li>
                <a  href="https://www.linkedin.com/in/siva-prasad-n-018416231?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app" target='_blank'>
                    <i class="fab fa-linkedin-in"></i>
                </a>
            </li>
        </ul>
        <div class="footer-right-bar d-none d-md-block">
            <a  href="connectwithsivaprasad@gmail.com" target='_blank'>connectwithsivaprasad@gmail.com </a>
        </div>
    </div>

    <div class="footer-credits text-center" >
        <!-- <a  href="https://github.com/loayeldin" target="_blank" rel="nofollow noopener noreferrer"> -->
            <div>Built by siva</div>
        <!-- </a> -->
        <!-- <a  href="https://github.com/andresjosehr/andresjosehr-portfolio" target="_blank" rel="nofollow noopener noreferrer">
            <div class="mt-2">Designed by Brittany Chiang & Jośe Andreś</div>
        </a> -->
    </div>

</footer>